module.exports = __webpack_public_path__ + "img/01-iPhone.eac10071.png";